import styled from 'styled-components';
import { Icon } from '../../../components/common/icon/Icon';
import { PointBadge } from './PointBadge';

const targetList = [
  {
    desc: '야간에도 반듯하게 골타기 하고 싶어요.',
    opacity: 1,
  },
  {
    desc: '일손을 한명이라도 더 줄이고 싶어요.',
    opacity: 0.6,
  },
  {
    desc: '농지 최적화로 소득을 조금 더 키워보고 싶어요.',
    opacity: 0.4,
  },
  {
    desc: '목과 허리에 무리를 줄여서 일해보고 싶어요.',
    opacity: 0.2,
  },
];

const TargetDetail = ({ desc, opacity }: { desc: string; opacity: number }) => {
  return (
    <TargetDetailCard opacity={opacity}>
      <BubbleTailIcon>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none">
          <path
            d="M0.377841 8.40402C2.19822 7.23033 6.31341 4.18987 7.5 0.0390625V9.28602C5.51147 10.2947 3.13968 10.2765 0.458128 9.31421C0.065268 9.17323 0.0270427 8.63019 0.377841 8.40402Z"
            fill="#F2F2F7"
          />
        </svg>
      </BubbleTailIcon>
      <ChatBubbleBody>
        <ChatBubbleText>{desc}</ChatBubbleText>
      </ChatBubbleBody>
    </TargetDetailCard>
  );
};

export const TargetAudienceSection = () => {
  return (
    <Container>
      <TitleSection>
        <PointBadge title={'정답은?'} />
        <Title>{'혹시 이런 생각 하시나요?\n정답은 플루바 오토!'}</Title>
      </TitleSection>
      <TargetDetailsSection>
        {targetList.map((target) => {
          return <TargetDetail key={target.desc} desc={target.desc} opacity={target.opacity} />;
        })}
        <AutoChatBubbleCard>
          <AuChatBubbleBody>
            <AutoChatBubbleText>{'플루바 오토가 해결 해드려요!'}</AutoChatBubbleText>
          </AuChatBubbleBody>
          <AutoBubbleTailIcon>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none">
              <path
                d="M7.62216 8.40402C5.80178 7.23033 1.68659 4.18987 0.5 0.0390625V9.28602C2.48853 10.2947 4.86032 10.2765 7.54187 9.31421C7.93473 9.17323 7.97296 8.63019 7.62216 8.40402Z"
                fill="#34C77E"
              />
            </svg>
          </AutoBubbleTailIcon>
        </AutoChatBubbleCard>
      </TargetDetailsSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  white-space: pre-line;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const TitleHighlight = styled.span`
  color: var(--Light-Scheme-Color-primary-green, #34c77e);
`;

const TargetDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const TargetDetailCard = styled.div<{ opacity: number }>`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  align-self: stretch;

  opacity: ${(prop) => prop.opacity};
`;

const BubbleTailIcon = styled.div`
  display: flex;
  padding: var(--radius-small, 4px) 0px;
  align-items: flex-end;
  margin-right: -1px;
`;

const ChatBubbleBody = styled.div`
  display: flex;
  padding: 10px 12px;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const ChatBubbleText = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const AutoChatBubbleCard = styled.div`
  display: flex;
  padding-top: 16px;
  justify-content: center;
  align-items: flex-end;
  align-self: stretch;
`;

const AuChatBubbleBody = styled.div`
  display: flex;
  padding: 10px 12px;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-green, #34c77e);
`;

const AutoChatBubbleText = styled.p`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
`;

const AutoBubbleTailIcon = styled.div`
  display: flex;
  padding: var(--radius-small, 4px) 0px;
  align-items: flex-end;
  margin-left: -1px;
`;
